"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var template;
function createMacroMap(macro, value) {
    var obj = {};
    obj[macro] = value;
    return obj;
}
exports.default = {
    setTemplate: function (errorMessageTemplate) {
        template = errorMessageTemplate;
    },
    macroToValue: function (msg, macro, value) {
        var reg = new RegExp("{" + macro + "}", "g");
        return msg.replace(reg, value);
    },
    get: function (name, templateData) {
        var msg = template[name];
        if (!msg)
            throw Error("can't get the value of errorMessageTemplate['" + name + "']");
        if (arguments.length === 1)
            return msg;
        if (typeof templateData !== "object")
            templateData = createMacroMap(name, templateData);
        for (var macro in templateData)
            msg = this.macroToValue(msg, macro, templateData[macro]);
        return msg;
    }
};
